import { WATER_PRESETS_ML, WATER_PRESETS_OZ } from "utils/waterVolumeConverter"

interface WaterBottleIconProps {
  size: number
  unit: "ml" | "oz"
}

const SmallGlass = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M10.5501 17.3548L10.9474 20.5L11.7843 27.1253C11.8474 27.6252 12.2725 28 12.7764 28H19.2236C19.7275 28 20.1526 27.6252 20.2157 27.1253L21.2105 19.25L21.4805 17.1129M10.5501 17.3548L10 13H22L21.4805 17.1129M10.5501 17.3548C11.2363 16.871 12.538 16.3871 13.913 16.3871C16.2609 16.3871 16.2609 17.8387 18.087 17.8387C19.913 17.8387 21.4805 17.1129 21.4805 17.1129"
      stroke="#0FBDD4"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)

const MediumBottle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M14.2813 8.5C14.2813 10.0823 10.5 11.22 10.5 13.1064C10.5 15.638 10.5 14.8608 10.5 16.7595C10.5 17.342 11.1875 17.0419 11.1875 18.4266C11.1875 20 10.5 20.3714 10.5 20.9241C10.5 21.8584 10.5 23.8539 10.5 24.9873M14.2813 8.5H16H17.7187M14.2813 8.5C13.9016 8.5 13.5938 8.1922 13.5938 7.8125V6.83333C13.5938 6.3731 13.9669 6 14.4271 6H16H17.5729C18.0331 6 18.4062 6.3731 18.4062 6.83333V7.8125C18.4062 8.1922 18.0984 8.5 17.7187 8.5M10.5 24.9873C10.5 25.6161 10.5 24.3574 10.5 24.9873ZM10.5 24.9873C10.5 26.1872 10.5 27.2036 10.5 28.0009C10.5 29.1054 11.3954 30 12.5 30H16H19.5C20.6046 30 21.5 29.1046 21.5 28L21.5 24.9873L21.5 20.9241C21.5 20.3714 20.8125 20 20.8125 18.4266C20.8125 16.8531 21.5 17.342 21.5 16.7595L21.5 13.1064C21.5 11.22 17.7187 10.0823 17.7187 8.5M10.5 16.7759C11.2535 16.2438 12.2557 15.4458 13.7657 15.4458C16.3438 15.4458 16.6302 17.0419 18.6354 17.0419C20.6406 17.0419 21.5 16.7759 21.5 16.7759"
      stroke="#0FBDD4"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)

const TallBottle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M14.2813 4.41379L13.6429 4.42996V3.00933C13.6429 2.45972 14.0864 2.01312 14.636 2.00935L16 2L17.3571 2C17.9094 2 18.3571 2.44772 18.3571 3V4.41379H17.7187M14.2813 4.41379C14.2813 6.18594 10.5 7.84636 10.5 9.95916C10.5 12.7946 10.5 11.9241 10.5 14.0506C10.5 14.703 11.1875 14.5 11.1875 15.9178C11.1875 17.5 10.5 17.9759 10.5 18.5949C10.5 19.6415 10.5 21.9963 10.5 23.2658M14.2813 4.41379H16H17.7187M10.5 23.2658C10.5 23.97 10.5 22.5603 10.5 23.2658ZM10.5 23.2658C10.5 25.0443 10.5 26.7508 10.5 28.0009C10.5 29.1055 11.3954 30 12.5 30H16H19.5C20.6046 30 21.5 29.1046 21.5 28V23.2658M10.5 23.2658H21.5M17.7187 4.41379C17.7187 6.18594 21.5 7.84636 21.5 9.95916L21.5 14.0506C21.5 14.703 20.8125 14.5 20.8125 15.9178C20.8125 17.5 21.5 17.9759 21.5 18.5949L21.5 23.2658M10.5 14.069C11.2535 13.4731 12.2557 12.5793 13.7657 12.5793C16.3438 12.5793 16.6302 14.3669 18.6354 14.3669C20.6406 14.3669 21.5 14.069 21.5 14.069"
      stroke="#0FBDD4"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)

const LargeBottle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M13.8125 4.41379L13 4.42996V3.01079C13 2.46061 13.4444 2.01377 13.9946 2.01081L16 2L18 2C18.5523 2 19 2.44772 19 3V4.41379H18.1875M13.8125 4.41379C13.8125 6.18594 9.00002 6.84636 9.00001 8.95916C9 11.7946 9 11.9241 9 14.0506C9.00001 14.703 9.87501 14.5 9.87501 15.9178C9.87501 17.5 9.00001 17.9759 9 18.5949C9 19.1486 9 20.0684 9 21M13.8125 4.41379H16H18.1875M9 24.2658C9 24.97 9 23.5603 9 24.2658ZM9 24.2658C9 25.7719 9 27.042 9.00001 28.001C9.00001 29.1055 9.89544 30 11 30H16H21C22.1046 30 23 29.1046 23 28V24.2658M9 24.2658H23M9 24.2658C9 23.6679 9 21.8293 9 21M18.1875 4.41379C18.1875 6.18594 23 6.84636 23 8.95916L23 14.0506C23 14.703 22.125 14.5 22.125 15.9178C22.125 17.5 23 17.9759 23 18.5949L23 20.9304M23 24.2658L23 20.9304M9.00001 14.069C9.95903 13.4731 11.2346 12.5793 13.1564 12.5793C16.4376 12.5793 16.8021 14.3669 19.3542 14.3669C21.9063 14.3669 23 14.069 23 14.069M9 21L23 20.9304"
      stroke="#0FBDD4"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)

const ICONS = [SmallGlass, MediumBottle, TallBottle, LargeBottle]

const WaterBottleIcon = ({ size, unit }: WaterBottleIconProps) => {
  // Map size to icon index (0-3 for small to large)
  const presets = unit === "oz" ? WATER_PRESETS_OZ : WATER_PRESETS_ML
  const iconIndex = presets.indexOf(size as never)

  const IconComponent = ICONS[iconIndex] ?? SmallGlass
  return <IconComponent />
}

export default WaterBottleIcon
